module.exports = __webpack_public_path__ + "img/icons8_play_button.69a6312d.svg";